import types, { PERSIST_STATE } from './types';

const setDate = (days) => ({ type: types.SET_DATE, ...days });

const setInterval = (interval) => ({ type: types.SET_INTERVAL, ...interval });

const setAdvanced = (showAdvanceDetails) => ({ type: types.SET_ADVANCED, ...showAdvanceDetails });

const setRowData = (rowData) => ({ type: types.SET_ROWDATA, ...rowData });

const setGeoData = (geoData) => ({ type: types.SET_GEODATA, ...geoData });

const setSSE = (enableSSE) => ({ type: types.SET_ENABLESSE, ...enableSSE });

const setSearchSortData = (searchSortData) => ({
  type: types.SET_SEARCH_SORT_DATA,
  searchSortData,
});

const resetSearchSortData = () => ({ type: types.RESET_SEARCH_SORT });

const setSelectedColumns = (selectedColumns) => ({
  type: types.SET_SELECTED_COLUMNS,
  ...selectedColumns,
});

const setTableColumns = (tableColumns) => ({ type: types.SET_TABLE_COLUMNS, ...tableColumns });

const setAnchoredColumns = (anchoredColumns) => ({
  type: types.SET_ANCHORED_COLUMNS,
  ...anchoredColumns,
});

const persistState = (configuration) => ({ type: PERSIST_STATE, configuration });

const updateBase = (persistedState) => ({ type: types.UPDATE, persistedState });

const setAdvanceToggle = (advanceToggle) => ({ type: types.SET_ADVANCED_TOGGLE, ...advanceToggle });

export default {
  setDate,
  setInterval,
  setAdvanced,
  setRowData,
  setGeoData,
  setSSE,
  setSearchSortData,
  resetSearchSortData,
  setSelectedColumns,
  setTableColumns,
  setAnchoredColumns,
  persistState,
  updateBase,
  setAdvanceToggle,
};
